import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../../app.service';
import { isArrayWithData } from '../../../../utilities/array.helpers';
import { GatewayRequestsService } from '../../../../services/gateway-requests/gateway-requests.service';
import { catchError, finalize, tap } from 'rxjs';
import moment from 'moment';
import { ReportsService } from '../../../../services/reports/reports.service';

@Component({
    selector: 'app-webhook-events',
    templateUrl: './webhook-events.component.html',
    styleUrl: './webhook-events.component.css',
})
export class WebhookEventsComponent implements OnInit {
    reportData: any = [];

    isReportPendingRetrieval: boolean = false;
    fromDate?: Date;
    toDate?: Date;

    selectedCreditorCompanyName: string = '';
    selectedCreditorId: string = '';
    hasClickedSearch: boolean = false;

    constructor(
        private appService: AppService,
        private reportsService: ReportsService,
    ) {}

    public ngOnInit(): void {}

    get hasTableData(): boolean {
        return isArrayWithData(this.reportData);
    }

    get hasRequestResponse(): boolean {
        return (
            isArrayWithData(this.reportData) &&
            (!!this.reportData[0].rawRequest ||
                !!this.reportData[0].rawResponse)
        );
    }

    hasValidInputs = () => {
        if (!this.fromDate || !this.toDate) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide a From Date and a To Date',
            );
            return false;
        }

        if (!this.selectedCreditorId) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide a creditor',
            );
            return false;
        }

        return true;
    };

    getReport = () => {
        if (!this.hasValidInputs) {
            return;
        }

        this.hasClickedSearch = true;

        this.appService.isShowPageSpinner = true;
        this.reportsService
            .getWebhookEventsReport(
                this.selectedCreditorId,
                this.fromDate!,
                this.toDate!,
            )
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res)) {
                        this.reportData = res;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    exportReport = () => {
        if (!this.hasValidInputs) {
            return;
        }

        this.reportsService
            .downloadWebhookEventsReport(
                this.selectedCreditorId,
                this.fromDate!,
                this.toDate!,
            )
            .subscribe(
                (blob) => {
                    if (blob != null) {
                        const downloadUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        a.href = downloadUrl;
                        a.download = `WebhookEvents_${this.selectedCreditorCompanyName}_${moment(this.fromDate).format('YYYY-MM-DD')}_to_${moment(this.toDate).format('YYYY-MM-DD')}.csv`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(downloadUrl);
                    }
                },
                (error) => {
                    console.error('Download failed', error);
                },
            );
    };

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
        this.selectedCreditorId = event.CreditorId;
        this.selectedCreditorCompanyName = event.CompanyName;
    }
}
